import * as React from 'preact/compat'

import strings from './loading-strings'

import styles from '#css/common.pcss.json'

const getRandomString = () => {
  const key = Math.floor(Math.random() * strings.length)
  return strings[key]
}

interface LoadingProps {
  className?: string,
  string?: string
}

interface LoadingState {
  text: string
}

export default class Loading extends React.Component<LoadingProps, LoadingState> {
  state: LoadingState = {
    text: getRandomString()
  }

  interval: number = null

  componentDidMount() {
    if (!this.props.string) {
      this.interval = window.setInterval(() => {
        this.setState({
          text: getRandomString()
        })
      }, 3000)
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.interval)
  }

  render() {
    const { string, className } = this.props
    const { text } = this.state

    const classNames = [styles['loading']]

    if (className) {
      classNames.push(className)
    }

    return <div className={classNames.join(' ')} style='overflow-anchor: none'>
      <svg viewBox='0 0 40 40' style='width: 40px; height: 40px;'>
        <circle cx='20' cy='20' r='18' stroke='var(--green)' strokeWidth='2' strokeDasharray='84 29' fill='none'/>
      </svg>
      <span>{string || text}</span>
    </div>
  }
}
